import { Types } from "../actions/PlannedMaintenanceDetailActions";

const initialState = {
    taskDetailById: null,
    taskEkedList: {},
    sameLevelListById: null,
    breakdownRootCause: null,
    poolList: null,
    breakdownReasonGroupList: null,
    breakdownEffectList: null,
    technicianListByPoolId: null,
    plannedMaintenanceAssign: null,
    plannedMaintenance: null,
    setPlannedMaintenanceCloaseComplete: null,
    plannedMaintenancePause: null,
    plannedMaintenanceUpdateTask: null,
    AddTechnician: null,
    breakdownReasonPlaceByGroupId: null,
    BreakdownReasonDetail: null,
    plannedFiles: null,
    maintenancePauseReason: null,
    setTaskHistoryById: null,
    deleteTask: null,
    error: null,
};

export const PlannedMaintenanceDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                taskDetailById: action.payload.resultObject,
            };
        case Types.SET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                sameLevelListById: action.payload.resultObject,
            };
        case Types.SET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                breakdownRootCause: action.payload.resultObject,
            };
        case Types.SET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                poolList: action.payload,
            };
        case Types.SET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                poolList: null,
                breakdownReasonGroupList: action.payload,
            };

        case Types.SET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                breakdownReasonGroupList: null,
                breakdownEffectList: action.payload,
            };
        case Types.RESET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                breakdownEffectList: null,
            };
        case Types.SET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                technicianListByPoolId: action.payload.resultObject,
            };

        case Types.SET_PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                plannedMaintenanceAssign: action.payload,
            };
        case Types.SET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                plannedMaintenance: action.payload,
            };
        case Types.SET_PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                setPlannedMaintenanceCloaseComplete: action.payload,
            };

        case Types.SET_PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                plannedMaintenancePause: action.payload,
            };

        case Types.SET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                plannedMaintenanceUpdateTask: action.payload,
            };

        case Types.SET_ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                AddTechnician: action.payload,
            };
        case Types.SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                breakdownReasonPlaceByGroupId: action.payload,
            };
        case Types.SET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                BreakdownReasonDetail: action.payload,
            };
        case Types.SET_PLANNED_FILES:
            return {
                ...state,
                plannedFiles: action.payload,
            };

        case Types.SET_MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                maintenancePauseReason: action.payload,
            };

        case Types.SET_GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                setTaskHistoryById: action.payload,
            };

        case Types.SET_DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                deleteTask: action.payload,
            };
        case Types.RESET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                plannedMaintenanceUpdateTask: null,
            };

        case Types.SHOW_SNACK_MESSAGE_IN_PLANNED_MAINTENANCE_DETAIL:
            return {
                ...state,
                error: action.payload,
            };
        case Types.SET_EKED_EQUIPMENT_LIST_PLANNED:
            return {
                ...state,
                taskEkedList: action.payload || state.taskEkedList,
            };

        default:
            return state;
    }
};
